/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatbot_Launcher_LabelInputs */

const en_chatbot_launcher_label = /** @type {(inputs: Chatbot_Launcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask Lindevo`)
};

const lv_chatbot_launcher_label = /** @type {(inputs: Chatbot_Launcher_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jautāt Lindevo`)
};

/**
* | output |
* | --- |
* | "Ask Lindevo" |
*
* @param {Chatbot_Launcher_LabelInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const chatbot_launcher_label = /** @type {((inputs?: Chatbot_Launcher_LabelInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatbot_Launcher_LabelInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_chatbot_launcher_label(inputs)
	return en_chatbot_launcher_label(inputs)
});